module.exports = __webpack_public_path__ + "img/DenAnker6-min.4eecfd50.jpg";